interface MenuStyle {
    position: string;
    top: string;
    left: string;
    width: string;
}

const PORTAL_CLASS_NAMES = { menuPortal: () => 'component_select__root' };
const PORTAL_CLASS_NAMES_MULTI = { menuPortal: () => 'component_select__root component_multi_select' };

export function getMenuPortalProps(
    menuPortalTarget: HTMLElement | null | undefined,
    menuStyle: MenuStyle | undefined,
    isMulti = false,
) {
    if (!menuPortalTarget) return { menuStyle };
    return {
        menuStyle: undefined,
        menuPortalTarget,
        classNames: isMulti ? PORTAL_CLASS_NAMES_MULTI : PORTAL_CLASS_NAMES,
    };
}
